module.exports = __webpack_public_path__ + "static/media/wijn-rood-glas.6daf54fe.png";